<template>
  <router-link :to="to">
    <button
      class="block bg-nucleus-white border-2 border-nucleus-primaryBlue p-1 text-nucleus-text text-center text-lg capitalize w-full rounded-full transition align-center flex items-center justify-center"
    >
      <span class="icon-add text-3xl mr-4"></span>
      {{ name }}
    </button>
  </router-link>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    name: String,
    to: String,
  },
})
export default class AddButton extends Vue {}
</script>
